import { LanguagesEnum } from '@/api/enums';
import { DashboardType, LAST_SELECTED_DASHBOARD } from '@/common/constants';
import i18n from '@/i18n';
import moment from 'moment';

export const formatDate = (
  date: string | Date | undefined,
  format?: string,
  locale?: string,
) => {
  if (!date) {
    return null;
  }

  if (!locale) {
    const isAdminDashboard =
      localStorage.getItem(LAST_SELECTED_DASHBOARD) === DashboardType.ADMIN;
    if (isAdminDashboard) {
      locale =
        i18n.language === LanguagesEnum.DK ? i18n.language : LanguagesEnum.EN;
    } else {
      locale = i18n.language ?? LanguagesEnum.EN;
    }
  }

  // By default moment will convert to the local borwser time
  return moment(date).locale(locale).format(format);
};
